const SORT_PLOT_BY_ARR = [
  { label: 'po powierzchni od najmniejszej', searchableLabel: 'po powierzchni od najmniejszej', value: 'plotSizeDesc' },
  { label: 'po powierzchni od największej', searchableLabel: 'po powierzchni od największej', value: 'plotSizeAsc' },
  { label: 'po cenie od najtańszych', searchableLabel: 'po cenie od najtańszych', value: 'priceDesc' },
  { label: 'po cenie od najdroższych', searchableLabel: 'po cenie od najdroższych', value: 'priceAsc' },
];

export { SORT_PLOT_BY_ARR };
